export default {
  mounted(el, binding) {
    const { getValue } = binding.value || {}

    // Find the actual input element - could be the element itself or nested inside a Vue component
    let inputElement = el
    if (el.tagName !== 'INPUT') {
      // If applied to a Vue component, try to find the input element inside it
      inputElement = el.querySelector('input')
      
      // If we still don't have an input, check if the Vue component has an inputRef
      if (!inputElement && el.__vueParentComponent) {
        const componentInstance = el.__vueParentComponent
        if (componentInstance.refs && componentInstance.refs.inputRef) {
          inputElement = componentInstance.refs.inputRef
        } else if (componentInstance.exposed && componentInstance.exposed.inputRef) {
          inputElement = componentInstance.exposed.inputRef
        }
      }
    }

    if (!inputElement) {
      console.warn('PreventTypingWithValue directive: Could not find input element')
      return
    }

    el.__vuePreventTyping__ = {
      inputElement,
      keydownHandler: (event) => {
        // Get the current value using the provided function
        const currentValue = getValue ? getValue() : inputElement.value


        // Only prevent typing if there's actually a meaningful value
        let hasValue = false
        if (currentValue !== null && currentValue !== undefined) {
          if (typeof currentValue === 'object') {
            // For objects, check if it has meaningful content
            hasValue = currentValue !== null && Object.keys(currentValue).length > 0
          } else if (typeof currentValue === 'string') {
            // For strings, check if it's not empty
            hasValue = currentValue.length > 0
          } else {
            // For other types (numbers, booleans), consider them as having value
            hasValue = true
          }
        }

        if (hasValue) {
          const allowedKeys = [
            'Backspace', 'Delete', 'Tab', 'Enter', 'NumpadEnter', 'Escape',
            'ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Home', 'End'
          ]
          
          // Allow copy-paste operations (Ctrl/Cmd + C/V/A/X)
          const isCopyPasteOperation = (event.ctrlKey || event.metaKey) && 
            ['KeyC', 'KeyV', 'KeyA', 'KeyX'].includes(event.code)
          
          // Prevent typing if not an allowed key or copy-paste operation
          if (!allowedKeys.includes(event.code) && !isCopyPasteOperation) {
            event.preventDefault()
            return false
          }
        }
      },

      pasteHandler: (event) => {
        // Get the current value using the provided function
        const currentValue = getValue ? getValue() : inputElement.value
        
        // If there's a current value, we need to clear it before pasting
        if (currentValue !== null && currentValue !== undefined && 
            (typeof currentValue === 'object' || (typeof currentValue === 'string' && currentValue.length > 0))) {
          // Emit a custom event that the component can listen to
          const clearEvent = new CustomEvent('clear-before-paste', {
            detail: { originalEvent: event }
          })
          el.dispatchEvent(clearEvent)
        }
      }
    }

    // Add event listeners to the actual input element
    inputElement.addEventListener('keydown', el.__vuePreventTyping__.keydownHandler)
    inputElement.addEventListener('paste', el.__vuePreventTyping__.pasteHandler)
  },

  beforeUnmount(el) {
    if (el.__vuePreventTyping__) {
      const { inputElement, keydownHandler, pasteHandler } = el.__vuePreventTyping__
      if (inputElement) {
        inputElement.removeEventListener('keydown', keydownHandler)
        inputElement.removeEventListener('paste', pasteHandler)
      }
      delete el.__vuePreventTyping__
    }
  },

  updated(el, binding) {
    // Update the getValue function if binding changes
    if (el.__vuePreventTyping__ && binding.value) {
      el.__vuePreventTyping__.getValue = binding.value.getValue
    }
  }
}
